export default {
  // Default
  default: {
    actions: {
      ok: 'Ok',
      add: 'Ajouter',
      send: 'Envoyer',
      cancel: 'Annuler',
      confirm: 'Valider',
      save: 'Enregistrer',
      delete: 'Supprimer',
      logout: 'Se déconnecter',
    },
  },
  home: {
    titles: {
      book: 'Jouer',
      my_bookings: 'Mes réservations',
      my_membership_1: 'Mes adhésions',
      my_membership_2: 'Mes cotisations',
      my_membership_3: 'Mes abonnements',
      my_profile: 'Mon profil',
      my_tournaments: 'Mes compétitions',
    },
    subtitles: {
      book: 'Réserver votre green-fee en quelques secondes',
      my_bookings: 'Consulter votre historique de réservations',
      my_membership_1: 'Consulter et payer votre adhésion',
      my_membership_2: 'Consulter et payer votre cotisation',
      my_membership_3: 'Consulter et payer votre abonnement',
      my_profile: 'Consulter ou modifier votre compte',
      my_tournaments: 'Bientôt disponible',
    },
  },
  // Temporary fix : ApolloClient network error cannot be overidden
  'TypeError: Network request failed': 'Connexion réseau interrompue',
  // Navigation
  navigation: {
    home: 'Accueil',
    booking: 'Réserver',
    academy: 'Académie',
    event: 'Événements',
    event_407: 'Cours - EDG',
    enter: 'S\'inscrire',
    schedule: 'Planning',
    directory: 'Annuaire',
    tournament: 'Compétitions',
    membership_1: 'Adhésions',
    membership_2: 'Cotisations',
    membership_3: 'Abonnements',
    members_1: 'Les adhérents',
    members_2: 'Les membres',
    members_3: 'Les abonnés',
    my_account: 'Mon compte',
    my_profile: 'Mon profil',
    my_ids: 'Mes identifiants',
    my_academy: 'Mes cours',
    my_activities: 'Mes activités',
    my_events: 'Mes événements',
    my_statement: 'Mon relevé',
    my_contacts: 'Mes contacts',
    my_interests: 'Mes intérêts',
    my_bookings: 'Mes réservations',
    my_history: 'Mon historique',
    my_tournaments: 'Mes compétitions',
    my_creditcard: 'Ma carte bancaire',
    my_covid_certificate: 'Mon pass vaccinal',
  },
  // Auth module
  auth: {
    titles: {
      log_in: 'Connexion',
      sign_up: 'Inscription',
      forgot_password: 'Mot de passe oublié',
      register_final: 'Finaliser mon inscription',
      activation_code: 'Activer mon compte',
    },
    messages: {
      log_in: 'Connectez-vous au monde mobile du golf !',
      sign_in: 'Inscrivez-vous pour réserver en ligne',
      forgot_password: 'Renseignez votre adresse mail pour recevoir un e-mail de réinitilisation de mot de passe.',
    },
    form: {
      labels: {
        email: 'E-mail',
        password: 'Mot de passe',
      },
      actions: {
        log_in: 'Se connecter',
        sign_in: 'S\'inscrire',
        register_final: 'Finaliser',
        forgot_password: 'Mot de passe oublié',
      },
    },
  },
  // Booking module
  booking: {
    actions: {
      missing_rentals: {
        one: '1 location manquante',
        other: '{{count}} locations manquantes',
      },
    },
    titles: {
      course: 'Parcours',
      which_course: 'Quel parcours ?',
      which_course_type: 'Combien de trous ?',
      my_contacts: 'Autres joueurs',
      list_members_1: 'Annuaire des adhérents',
      list_members_2: 'Annuaire des membres',
      list_members_3: 'Annuaire des abonnés',
      list_corpo: 'Annuaire corpo',
    },
  },
  // Membership module
  membership: {
    titles: {
      principal_membership_1: 'Adhésion principale',
      principal_membership_2: 'Cotisation principale',
      principal_membership_3: 'Abonnement principal',
      additional_membership_1: 'Adhésion complémentaire',
      additional_membership_2: 'Cotisation complémentaire',
      additional_membership_3: 'Abonnement principal',
    },
    messages: {
      approve_schedule_1: `Votre adhésion d'un montant de %{amount} vous sera prélevée en 
        %{months} fois en suivant l'échéancier ci-dessous :`,
      approve_schedule_2: `Votre cotisation d'un montant de %{amount} vous sera prélevée en 
        %{months} fois en suivant l'échéancier ci-dessous : `,
      approve_schedule_3: `Votre abonnement d'un montant de %{amount} vous sera prélevée en 
        %{months} fois en suivant l'échéancier ci-dessous : `,
      sent_confirm_email: 'Un e-mail de confirmation vous a été envoyé à : ',
    },
    monthly_payment: {
      one: '1 mensualité',
      other: '{{count}} mensualités',
    },
  },
  // Directory module
  directory: {
    titles: {
      members_1: 'Annuaire des adhérents',
      members_2: 'Annuaire des membres',
      members_3: 'Annuaire des abonnés',
    },
  },
  // Primaccess module
  primaccess: {
    moves: {
      error_1: 'Badge désactivé',
      error_2: 'Solde insuffisant',
      error_3: 'Badge non autorisé',
      error_4: 'Accès restreint',
      error_40: 'Problème de lecture',
    },
  },
  // Terms,
  terms: {
    anonymous: 'anonyme',
    course: 'parcours',
    course_type_holes_1: '9',
    course_type_holes_2: '18',
    course_type_1: '9 trous',
    course_type_2: '18 trous',
    course_type_null: '',
    membership_1: 'adhésion',
    membership_2: 'cotisation',
    membership_3: 'abonnement',
    member_1: 'adhérent',
    member_2: 'membre',
    member_3: 'abonné',
    included: 'inclus',
    player: 'joueur',
    rental: 'location',
    tournament: 'Compétition',
    event: 'Évènement',
    status_confirmed: 'Prise le',
    status_updated: 'Modifiée le',
    status_canceled: 'Annulée le',
    status_refunded: 'Remboursée le',
    players: {
      one: '{{count}} joueur',
      other: '{{count}} joueurs',
    },
    rentals: {
      one: '{{count}} location',
      other: '{{count}} locations',
      zero: 'aucune location',
    },
    availability: {
      one: '{{count}} disponibilité',
      other: '{{count}} disponibilités',
      zero: 'aucune disponibilité',
    },
    persons: {
      one: '{{count}} personne',
      other: '{{count}} personnes',
    },
    nights: {
      one: '{{count}} nuit',
      other: '{{count}} nuits',
    },
    entrants: {
      one: '{{count}} participant',
      other: '{{count}} participants',
    },
    day: 'jour',
    month: 'mois',
    week: 'semaine',
    quota_exceeded: 'hors quota',
    price_overrided: 'tarif réduit',
  },
  event: {
    title: 'Événements - Calendrier',
    not_found: 'Aucun événement.',
  },
  event_voucher: {
    title: 'Événements - Confirmation d\'inscription',
  },
  event_pay: {
    title: 'Événements - Paiement par CB',
    not_complete1: 'Votre inscription est incomplète !',
    not_complete2: 'Veuillez choisir une option pour les événements obligatoires.',
  },
  event_past: {
    title: 'Mes événements',
    sub_title: 'Mes événements passés',
  },
  event_next: {
    sub_title: 'Mes prochains événements',
  },
  event_calendar: {
    title: 'Évévenements - Calendrier',
    choose: 'Choisissez votre événement',
    not_found: 'Aucun événement.',
  },
  event_signin: {
    title: 'Événements - S\'inscrire',
  },
  event_view: {
    show: 'Voir l\'événement',
  },
  event_enter: {
    already_in: 'Vous êtes déjà inscrit à cet événement.',
  },
  event_history: {
    list: {
      not_found: 'Aucun événement pour le moment.',
    },
    view: {
      title: 'Mon événement',
      cancellable: 'L\'annulation concerne l\'inscription à l\'événement ainsi qu\'à la compétition.',
    },
  },
};
